import { useEffect, useState, useMemo } from 'react';
import Main from '../../cpn/Main';
import { Col, Flex, Form, Radio, Row, Tabs } from 'antd';
import { useGetXMTree2Query, useGetXMTreeQuery } from '../../store/BnsKeJiApi';
import InterfaceInfo from '../interface/InterfaceInfo';
import ProjectAdd from './ProjectAdd';
import ProjectDropdown from './ProjectDropdown';
function ProjectTabs() {
    // 使用useMemo缓存localStorage的值，避免每次渲染都重新读取
    const initialValues = useMemo(() => {
        try {
            const filterType = JSON.parse(localStorage.getItem('goldfish_ProjectTabs_filterType') || 'null')
            const bg_state = JSON.parse(localStorage.getItem('goldfish_ProjectTabs_bg_state') || 'null')
            const et_status = JSON.parse(localStorage.getItem('goldfish_ProjectTabs_et_status') || 'null')
            
            
            return {
                filterType: filterType || '1',
                bg_state: bg_state || '',
                et_status: et_status || '1'
            };
        } catch (error) {
            console.error('ProjectTabs初始化错误:', error);
            return {
                filterType: '1',
                bg_state: '',
                et_status: '1'
            };
        }
    }, []); // 空依赖数组，只在组件首次挂载时执行
    
    const eu_id = localStorage.getItem('eu_id');
    const eu_name = localStorage.getItem('eu_name');
    const [filterType,setFileterType] = useState(initialValues.filterType)
    const [query, setQuery] = useState({
        et_e_id:'218',
        et_status:initialValues.et_status,
    });   
    const [list,setList] = useState([])
    const [list2,setList2] = useState([])
    
    const {data, isSuccess} = useGetXMTreeQuery(query,{refetchOnMountOrArgChange:1,skip:filterType==='2'});    
    useEffect(() => {
        if (isSuccess) {
            if(data.Status==='success'){               
                setList(data.Result)
            }else{
                setList([])
            }
            
        }
    }, [data, isSuccess])      

    // 根据filterType决定使用哪个数据源
    const currentList = filterType === '1' ? list : list2;
    
    // 生成Tabs的items，数据表名称：bns_ent_task
    const tabItems = currentList.map((item, index) => ({
        key: item.value || index.toString(),
        label: <>{item.title} <ProjectDropdown bg_id={item.value} bg_name={item.title} /></>,
        children: <InterfaceInfo children={item.children} bg_id={item.value}  bg_name={item.title} eu_id={eu_id} eu_name={eu_name} query_et_status={query.et_status}/>
    }));
    const [query2, setQuery2] = useState({
        bg_e_id:'218',
        et_bg_type_id:initialValues.bg_state,
    });  
    const {data:data2, isSuccess:isSuccess2} = useGetXMTree2Query(query2,{refetchOnMountOrArgChange:1,skip:filterType==='1'});    
    useEffect(() => {
        if (isSuccess2) {
            if(data2.Status==='success'){               
                setList2(data2.Result)
            }else{
                setList2([])
            }
            
        }
    }, [data2, isSuccess2])     
    // 生成Tabs的items
    const tabItems2 = list2.map((item, index) => ({
        key: item.value || index.toString(),
        label: <>{item.title} <ProjectDropdown bg_id={item.value} bg_name={item.title} /></>,
        children: <InterfaceInfo children={item.children} bg_id={item.value}  bg_name={item.title} eu_id={eu_id} eu_name={eu_name} query_et_status={query.et_status}/>
    }));
    // 移除可能导致无限重新渲染的useEffect

    // 移除调试日志，避免不必要的重新渲染

    return (
        <Main selectedKeys={['/ProjectTabs']}>
            <Row>
                <Col span={24}>
                    <Flex justify='space-between' align='center'>
                        <Form layout='inline' name='filter_form'>
                            <Form.Item label='按任务状态查询'>
                                <Radio.Group 
                                    value={query.et_status}
                                    optionType="button" 
                                    buttonStyle="solid" 
                                    onChange={(e) => {
                                        setQuery(prev=>({...prev,et_status:e.target.value}))
                                        localStorage.setItem('goldfish_ProjectTabs_et_status',JSON.stringify(e.target.value))
                                        setFileterType('1')
                                        localStorage.setItem('goldfish_ProjectTabs_filterType',JSON.stringify('1'))
                                        
                                        // 清空按项目状态查询的选中状态
                                        setQuery2(prev=>({...prev,et_bg_type_id:null}))
                                        localStorage.setItem('goldfish_ProjectTabs_bg_state',JSON.stringify(null))
                                    }}
                                >
                                    <Radio value='1'>待完成</Radio>
                                    <Radio value='2'>待验收</Radio>
                                    <Radio value='3'>已完成</Radio>
                                </Radio.Group>  
                            </Form.Item>
                            <Form.Item label='按项目状态查询'>
                                <Radio.Group 
                                    optionType="button" 
                                    buttonStyle="solid" 
                                    onChange={(e) => {
                                        const newValue = e.target.value;
                                        setQuery2(prevState => ({...prevState, et_bg_type_id: newValue}));
                                        localStorage.setItem('goldfish_ProjectTabs_bg_state', JSON.stringify(newValue));
                                        setFileterType('2');
                                        localStorage.setItem('goldfish_ProjectTabs_filterType', JSON.stringify('2'));
                                        
                                        // 清空按任务状态查询的选中状态
                                        setQuery(prev=>({...prev,et_status:null}))
                                        localStorage.setItem('goldfish_ProjectTabs_et_status',JSON.stringify(null))
                                    }}
                                    value={query2.et_bg_type_id}
                                >
                                    <Radio value=''>全部项目</Radio>
                                    <Radio value='1'>开发中</Radio>
                                    <Radio value='2'>使用中</Radio>
                                    <Radio value='3'>已停用</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Form>
                        <ProjectAdd />
                    </Flex>
                </Col>
                <Col span={24} style={{ marginTop: '20px'}}>
                    {filterType==='1'?<Tabs
                                            type="card"
                                            items={tabItems}
                                            defaultActiveKey={tabItems.length > 0 ? tabItems[0].key : undefined}
                                            style={{marginBottom:"0"}}
                                            tabBarStyle={{marginBottom: 0}}
                                        />:<Tabs
                                            type="card"
                                            items={tabItems2}
                                            defaultActiveKey={tabItems2.length > 0 ? tabItems2[0].key : undefined}
                                            style={{marginBottom:"0"}}
                                            tabBarStyle={{marginBottom: 0}}
                                        />}
                </Col>                
            </Row>
        </Main>
    );
}

export default ProjectTabs;